import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";
import { InstallNudge } from "./components/InstallNudge";
import { LockScreen } from "./components/LockScreen";
import Setup from "./pages/Setup";
import Ask from "./pages/Ask";
import Answer from "./pages/Answer";
import Inbox from "./pages/Inbox";
import Modify from "./pages/Modify";
import Recents from "./pages/Recents";
import TagFilter from "./pages/TagFilter";
import Settings from "./pages/Settings";
import PasscodeChange from "./pages/PasscodeChange";
import SuggestionsEdit from "./pages/SuggestionsEdit";

export default function App() {
  const { setupComplete, unlocked, offline } = useAuth();
  if (setupComplete === null) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center p-8 text-center text-attic-dim">
        {offline ? (
          <>
            <p className="text-3xl mb-2">📡</p>
            <p className="font-semibold text-attic-text">You're offline</p>
            <p className="text-xs mt-1">Reconnect to load attic</p>
          </>
        ) : (
          <p>Loading…</p>
        )}
      </div>
    );
  }
  if (setupComplete === false) {
    return (
      <Routes>
        <Route path="*" element={<Setup />} />
      </Routes>
    );
  }
  if (!unlocked) {
    return <LockScreen />;
  }
  return (
    <>
      <Routes>
        <Route path="/" element={<Ask />} />
        <Route path="/answer/:id" element={<Answer />} />
        <Route path="/inbox" element={<Inbox />} />
        <Route path="/recents" element={<Recents />} />
        <Route path="/modify/:vault/:slug" element={<Modify />} />
        <Route path="/tag/:vault/:tag" element={<TagFilter />} />
        <Route path="/setup" element={<Navigate to="/" replace />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/settings/passcode" element={<PasscodeChange />} />
        <Route path="/settings/suggestions/:vault" element={<SuggestionsEdit />} />
      </Routes>
      <InstallNudge />
    </>
  );
}
